export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "thrusterCalculate.worker.4bb7ceba5c879c5a985e-thrusterCalculate.worker.worker.js");
}
